import { IState } from '../lib/store';
import { IApiKey } from '../types/api_keys';
import { DeepReadonly } from '../types/typescript_helpers';

export const getApiKeyList = (state: IState): DeepReadonly<IApiKey[]> => state.apiKeys || [];
